import {Injectable}					      from '@angular/core';
import {Http, Response}				    from '@angular/http';
import {Headers, RequestOptions}	from '@angular/http';
import {ContentRow}				      from './content-row';
import {Observable}					      from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/catch';
//import 'rxjs/add/operator/publish';
import { environment } from '../environments/environment';
import { ConfigService } from './config.service';

@Injectable()
export class ContentService {
	constructor(private http: Http, private configService: ConfigService) {}

	public _config = this.configService.getConfiguration();
    public _contentNodesUrl = //'http://localhost:54432/webapi/kabaut/he/shalhevet/getRequirmentsByCategoryId/';
				this._config.webApiBaseUrl + 'getRequirmentsByCategoryId/';
	public _isTestData = this._config.isTestData;

	contentRows: ContentRow[];

	getContentNodes (catId:number) {
        console.log('parentId = ' + catId);
		debugger;

        return this.http.get(this._contentNodesUrl + catId + (this._isTestData ? '/Test' : ''))
                .map(res => (this.contentRows = 
					<ContentRow[]> res.json()).filter(
					(row,ix,rows)=>{
                        var parts = row.REQUIREMENT_NUMBER.split('.');
						//return parts[0] != '' && parts.length == 1;
                        return true;
					}))
				.do(data => {
					console.log(data);
					//this.contentNodes = data; 
				})
				.catch(this.handleError);



	}

	private handleError (error: Response) {
		console.error(error);
		return Observable.throw(error.json().error || 'Server error');
	}
}


// WEBPACK FOOTER //
// ./src/app/content.service.ts